// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customFullWidthInput[data-v-7f3218de]{\n  width: 100% !important;\n}\n.fullWidth[data-v-7f3218de]{\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n.customIcon[data-v-7f3218de]{\n  top: 0 !important;\n  height: 33px;\n}\n", ""]);
// Exports
module.exports = exports;
